import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { areTableNamesEqual } from "common/generator/description";
import { NotebookWithTableName } from "store/types";
import { defaultRootState } from "./default-root-state";

const notebookStateSlice = createSlice({
    name: "notebook",
    initialState: defaultRootState.notebook,
    reducers: {
        setNotebook: (state, action: PayloadAction<NotebookWithTableName>) => {
            const toReplaceIndex = state.notebooks.findIndex(n =>
                areTableNamesEqual(action.payload.tableName, n.tableName)
            );
            if (toReplaceIndex === -1) {
                state.notebooks.push(action.payload as any);
            } else {
                state.notebooks[toReplaceIndex] = action.payload as any;
            }
        },
    },
});

export const { setNotebook } = notebookStateSlice.actions;
export default notebookStateSlice.reducer;
